import ButtonFunction from "./shared/ButtonFunction";
import TextInputHorizontalTag from "./shared/TextInputHorizontalTag";
import NavLabel from "./shared/NavLabel";
import GeneralContext from "../context/GeneralContext";
import { useContext, useState } from "react";
import {fetchBody} from '../utils/fetch';

function PassQuestionCard() {

    const {
      changeActiveMode,
      changeModalTitle,
      changeModalText,
      changeModalType,
      activePasswordDocument,
      activePasswordQuestion,
      setActivePasswordId
    } = useContext(GeneralContext);

    const [answer, setAnswer] = useState("");
    const changeAnswer = (e) => {
      setAnswer(e.target.value);
    }
    
    const loginMode = () => {
      changeActiveMode('login');
    }

    const passQuestionFunction = async () => {
      const modal = document.getElementById("myModal");
      if (answer === '') {
        changeModalTitle('Error');
        changeModalText('La respuesta no puede estar vacía');
        changeModalType('alert');
        modal.style.display = "block";
      } else {
        const data = {document: activePasswordDocument, answer: answer};
        const response = await fetchBody('security_answer', 'POST', data);
        if (response.success) {
          setActivePasswordId(response.id);
          changeActiveMode('newpass');
        } else {
          changeModalTitle('Error al intentar la operación');
          changeModalText(response.reason);
          changeModalType('alert');
          modal.style.display = "block";
        }
      }
    }

  return (
    <div id='loginCard'>
      <>
        <h2>Pregunta de seguridad</h2>
        <p>{activePasswordQuestion}</p>
        <TextInputHorizontalTag label='Respuesta' changeEvent={changeAnswer}/>
        <br />
        <ButtonFunction buttonClass='loginButton' buttonFunction={passQuestionFunction}>Responder</ButtonFunction>
        <br />
        <br />
        <NavLabel navFunction={loginMode}>Regresar a ingreso</NavLabel>
      </>
    </div>
  )
}

export default PassQuestionCard